import { set } from 'lodash/fp';
import createReducer from '../../../../../../helpers/createReducer';
import { createROItem } from '../../../../sagas/routines';

const initialState = {
  saving: false,
  saved: false
};

export const createROItemHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: set('saved', true),
  [routine.FULFILL]: set('saving', false)
});

export default createReducer(initialState, {
  ...createROItemHandler(createROItem)
});
